import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PRESET_COLORS } from '@/atoms/color/color-picker';
import type { WorkspaceFormValues } from '../form/form.workspace';
import { WorkspaceForm } from '../form/form.workspace';

const getCreateDefaults = (workspaceCount: number): WorkspaceFormValues => ({
  name: '',
  color: PRESET_COLORS[workspaceCount % PRESET_COLORS.length],
  version: null
});

type Props = {
  visible: boolean;
  processId: string;
  workspaceCount: number;
  onSubmit: (values: WorkspaceFormValues) => void | Promise<void>;
  onCancel: () => void;
};

export const CreateWorkspacePanel = ({
  visible,
  processId,
  workspaceCount,
  onSubmit,
  onCancel
}: Props) => {
  const shouldReduceMotion = useReducedMotion();

  return (
    <AnimatePresence initial={false}>
      {visible && (
        <motion.div
          animate={{ height: 'auto', marginBottom: 0, opacity: 1 }}
          className="overflow-hidden rounded-lg bg-white shadow-verail"
          exit={{ height: 0, marginBottom: '-16px', opacity: 0 }}
          initial={
            shouldReduceMotion
              ? false
              : { height: 0, marginBottom: '-16px', opacity: 0 }
          }
          key="create-form"
          transition={{ duration: 0.25, ease: [0.23, 1, 0.32, 1] }}
        >
          <div className="p-6">
            <h3 className="mb-4 font-normal text-base">New workspace</h3>
            <WorkspaceForm
              autoFocusName
              defaultValues={getCreateDefaults(workspaceCount)}
              onCancel={onCancel}
              onSubmit={onSubmit}
              processId={processId}
              submitLabel="Create"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
